import { useEffect } from "react";
import { recordSavedSearchVisitApi, updateHomePreferencesApi } from "../../api/homeApi";

/**
 * One Saved Search visit (FE #700, R8/G9, Spec §7).
 *
 * Opening records the visit (the first one sets the +N baseline) and the
 * last-opened search. The visit ends when the user leaves the search or the
 * tab goes away; only then is it marked seen, so opening a +N pill does not
 * itself clear the new companies. Legacy workspaces have no visit record and
 * the server's 404 is ignored.
 */
export default function useSavedSearchVisit(savedSearchId) {
  useEffect(() => {
    if (!savedSearchId) return undefined;
    let ended = false;
    recordSavedSearchVisitApi(savedSearchId, { ended: false });
    updateHomePreferencesApi({ last_opened_saved_search_id: savedSearchId });

    const end = () => {
      if (ended) return;
      ended = true;
      recordSavedSearchVisitApi(savedSearchId, { ended: true, keepalive: true });
    };
    window.addEventListener("pagehide", end);
    return () => {
      window.removeEventListener("pagehide", end);
      end();
    };
  }, [savedSearchId]);
}
